import { render, staticRenderFns } from "./AMap.vue?vue&type=template&id=8d629cf0&scoped=true"
import script from "./AMap.vue?vue&type=script&lang=js"
export * from "./AMap.vue?vue&type=script&lang=js"
import style0 from "./AMap.vue?vue&type=style&index=0&id=8d629cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d629cf0",
  null
  
)

export default component.exports